import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { useIntl } from 'react-intl';

import http from 'src/services/httpService';
import ContentManager from 'src/componentes/content-manager';
import LucideIcon from 'src/componentes/lucide-icon';
import { capitalizeFirstLetter } from 'src/utils/string';
import errorHandler from 'src/utils/error-handler';

import Edit from '../RiscoAvaliacaoPowerBIEditView';

function Actions({ endpoint, onRefresh, item, parameters }) {
  const intl = useIntl();

  const handleEdit = () => {
    ContentManager.addContent(
      <Edit handleClose={onRefresh} id={item?.id} parameters={parameters} />
    );
  };

  const handleDelete = async () => {
    if (!item) return;

    try {
      await http.post(`${endpoint}/Remove`, { id: item.id });
      onRefresh && onRefresh();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          color="default"
          size="sm"
          toolbar
          icon="dots-vertical"
        />
        <DropdownMenu>
          <DropdownItem onClick={() => handleEdit()}>
            <LucideIcon icon="pencil" />
            {capitalizeFirstLetter(intl.formatMessage({ id: 'editar' }))}
          </DropdownItem>
          <DropdownItem onClick={handleDelete}>
            <LucideIcon icon="delete-outline" />
            {capitalizeFirstLetter(intl.formatMessage({ id: 'excluir' }))}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
}

export default Actions;
